export const US_STATES = [
    { abbr: 'AL', name: 'Alabama' },
    { abbr: 'AK', name: 'Alaska' },
    { abbr: 'AZ', name: 'Arizona' },
    { abbr: 'AR', name: 'Arkansas' },
    { abbr: 'CA', name: 'California' },
    { abbr: 'CO', name: 'Colorado' },
    { abbr: 'CT', name: 'Connecticut' },
    { abbr: 'DE', name: 'Delaware' },
    { abbr: 'FL', name: 'Florida' },
    { abbr: 'GA', name: 'Georgia' },
    { abbr: 'HI', name: 'Hawaii' },
    { abbr: 'ID', name: 'Idaho' },
    { abbr: 'IL', name: 'Illinois' },
    { abbr: 'IN', name: 'Indiana' },
    { abbr: 'IA', name: 'Iowa' },
    { abbr: 'KS', name: 'Kansas' },
    { abbr: 'KY', name: 'Kentucky' },
    { abbr: 'LA', name: 'Louisiana' },
    { abbr: 'ME', name: 'Maine' },
    { abbr: 'MD', name: 'Maryland' },
    { abbr: 'MA', name: 'Massachusetts' },
    { abbr: 'MI', name: 'Michigan' },
    { abbr: 'MN', name: 'Minnesota' },
    { abbr: 'MS', name: 'Mississippi' },
    { abbr: 'MO', name: 'Missouri' },
    { abbr: 'MT', name: 'Montana' },
    { abbr: 'NE', name: 'Nebraska' },
    { abbr: 'NV', name: 'Nevada' },
    { abbr: 'NH', name: 'New Hampshire' },
    { abbr: 'NJ', name: 'New Jersey' },
    { abbr: 'NM', name: 'New Mexico' },
    { abbr: 'NY', name: 'New York' },
    { abbr: 'NC', name: 'North Carolina' },
    { abbr: 'ND', name: 'North Dakota' },
    { abbr: 'OH', name: 'Ohio' },
    { abbr: 'OK', name: 'Oklahoma' },
    { abbr: 'OR', name: 'Oregon' },
    { abbr: 'PA', name: 'Pennsylvania' },
    { abbr: 'RI', name: 'Rhode Island' },
    { abbr: 'SC', name: 'South Carolina' },
    { abbr: 'SD', name: 'South Dakota' },
    { abbr: 'TN', name: 'Tennessee' },
    { abbr: 'TX', name: 'Texas' },
    { abbr: 'UT', name: 'Utah' },
    { abbr: 'VT', name: 'Vermont' },
    { abbr: 'VA', name: 'Virginia' },
    { abbr: 'WA', name: 'Washington' },
    { abbr: 'WV', name: 'West Virginia' },
    { abbr: 'WI', name: 'Wisconsin' },
    { abbr: 'WY', name: 'Wyoming' },
    { abbr: 'DC', name: 'District of Columbia' },
];

export const CA_PROVINCES = [
    { abbr: 'AB', name: 'Alberta' },
    { abbr: 'BC', name: 'British Columbia' },
    { abbr: 'MB', name: 'Manitoba' },
    { abbr: 'NB', name: 'New Brunswick' },
    { abbr: 'NL', name: 'Newfoundland and Labrador' },
    { abbr: 'NS', name: 'Nova Scotia' },
    { abbr: 'NT', name: 'Northwest Territories' },
    { abbr: 'NU', name: 'Nunavut' },
    { abbr: 'ON', name: 'Ontario' },
    { abbr: 'PE', name: 'Prince Edward Island' },
    { abbr: 'QC', name: 'Quebec' },
    { abbr: 'SK', name: 'Saskatchewan' },
    { abbr: 'YT', name: 'Yukon' },
];

export const COUNTRIES = [
    { code: 'US', name: 'United States' },
    { code: 'CA', name: 'Canada' },
];

const COUNTRY_ALIASES = {
    us: 'US',
    usa: 'US',
    'united states': 'US',
    'united states of america': 'US',
    ca: 'CA',
    can: 'CA',
    canada: 'CA',
};

const COUNTRY_DISPLAY_NAMES = {
    US: 'United States',
    CA: 'Canada',
};

const ALL_REGIONS = [...US_STATES, ...CA_PROVINCES];

export const normalizeCountryCode = (value) => {
    if (!value) return null;
    return COUNTRY_ALIASES[String(value).trim().toLowerCase()] || null;
};

export const normalizeRegionCode = (value) => {
    const trimmed = String(value || '').trim();
    if (!trimmed) return '';
    if (trimmed.length === 2) return trimmed.toUpperCase();
    const lower = trimmed.toLowerCase();
    const match = ALL_REGIONS.find((region) => region.name.toLowerCase() === lower);
    return match ? match.abbr : trimmed.toUpperCase();
};

export const inferCountryFromState = (stateValue) => {
    const abbr = normalizeRegionCode(stateValue);
    if (CA_PROVINCES.some((province) => province.abbr === abbr)) return 'CA';
    if (US_STATES.some((state) => state.abbr === abbr)) return 'US';
    return null;
};

export const resolveCountryCode = (countryValue, stateValue, defaultCode = 'US') =>
    normalizeCountryCode(countryValue) || inferCountryFromState(stateValue) || defaultCode;

export const getRegionsForCountry = (countryCode) =>
    countryCode === 'CA' ? CA_PROVINCES : US_STATES;

export const getRegionSelectOptions = (countryCode, currentValue) => {
    const regions = getRegionsForCountry(countryCode);
    if (currentValue && !regions.some((region) => region.abbr === currentValue)) {
        return [{ abbr: currentValue, name: currentValue }, ...regions];
    }
    return regions;
};

export const isRegionInCountry = (countryCode, stateValue) => {
    const abbr = normalizeRegionCode(stateValue);
    return getRegionsForCountry(countryCode).some((region) => region.abbr === abbr);
};

export const applyCountryChange = (prev, country) => ({
    ...prev,
    country,
    state: isRegionInCountry(country, prev.state) ? normalizeRegionCode(prev.state) : '',
});

export const getStateProvinceLabel = (countryCode) =>
    countryCode === 'CA' ? 'Province' : 'State';

export const getPostalCodeLabel = (countryCode) =>
    countryCode === 'CA' ? 'Postal Code' : 'Zip Code';

export const countryDisplayName = (countryValue, stateValue) => {
    const code = resolveCountryCode(countryValue, stateValue, null);
    if (!code) return String(countryValue || '').trim();
    return COUNTRY_DISPLAY_NAMES[code] || code;
};
